/*
 * @Author: ZJJ
 * @Date: 2025-11-05 19:13:16
 * @LastEditTime: 2025-11-28 11:50:26
 * @FilePath: /boluo_website/src/main.js
 * @Description:
 */
import Vue from "vue";
import App from "./App.vue";
import Aegis from "aegis-web-sdk";
import router from "./router";
import store from "./store";

Vue.prototype.$EventBus = new Vue();

Vue.config.productionTip = false;
import "./assets/icons"; // icon
import "./assets/css/common.less";
import "./assets/css/common.css";

import "./assets/css/theme/dark.css";
import "./assets/css/theme/light.css";

import { Swiper as TSwiper } from "tdesign-vue";
import { SwiperItem as TSwiperItem } from "tdesign-vue";
import { message as TMessage } from "tdesign-vue";
import { Loading as TLoading } from "tdesign-vue";
import { Slider as TSlider } from "tdesign-vue";
import { QRCode as TQRCode } from "tdesign-vue";

// 引入组件库的少量全局样式变量
import "tdesign-vue/es/style/index.css";

import "vue-slider-component/theme/default.css";

// 初始化 Aegis 实例
const aegis = new Aegis({
  id: process.env.VUE_APP_AEGIS_ID, // 上报 id
  uin: "xxx", // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: "https://rumt-zh.com"
});
Vue.prototype.$aegis = aegis;

Vue.use(TSwiper);
Vue.use(TSwiperItem);
Vue.use(TSlider);
Vue.use(TLoading);
Vue.use(TQRCode);
// Message 是函数式 API，需要手动添加到 Vue 原型上
Vue.prototype.$message = TMessage;

if (process.env.NODE_ENV === "production") {
  //development  production
  // 如想保留 console.warn / console.error 只屏蔽 log
  console.log = () => {};
  // 或者干脆全干掉
  // console = {};
}

let vueDom = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vueDom;
